const VerticalDottedDivider = () => {
  return <div className="border-l-2 border-dashed opacity-20 border-white ml-20 h-32" />;
};

export default VerticalDottedDivider;
